import { z } from 'zod';
import { BOM_INSTRUCTION_CONSTRAINTS } from './constraints.js';
export const bomInstructionNameSchema = z
    .string()
    .trim()
    .min(1, `${BOM_INSTRUCTION_CONSTRAINTS.name.label} is required.`)
    .max(BOM_INSTRUCTION_CONSTRAINTS.name.maxLength, `${BOM_INSTRUCTION_CONSTRAINTS.name.label} must be ${BOM_INSTRUCTION_CONSTRAINTS.name.maxLength} characters or fewer.`);
export const bomInstructionDetailsSchema = z.string().trim().nullable().optional();
export const bomInstructionDescriptionSchema = z
    .string()
    .trim()
    .max(BOM_INSTRUCTION_CONSTRAINTS.description.maxLength, `${BOM_INSTRUCTION_CONSTRAINTS.description.label} must be ${BOM_INSTRUCTION_CONSTRAINTS.description.maxLength} characters or fewer.`)
    .nullable()
    .optional();
//# sourceMappingURL=instruction-form.js.map